import OkC from "shared/util/OkcApi";

export function confirmToken(token) {
	return OkC.post("/recaptcha/confirm_token", {
		data: {
			token,
		},
	});
}



// WEBPACK FOOTER //
// ./src/shared/util/ReCaptcha/index.js